import React, { useContext } from 'react';
import { ModalContext, IModalContext } from 'contexts/modal';
import { UserContext, IUserContext } from 'contexts/user';
import formatCurrency from 'utils/format-currency';
import styles from './style.module.scss';
import { listingPageModalIds, blurIds } from 'constants/test-constants';
import { useTranslation } from 'react-i18next';
import { SiteNameSpace } from 'constants/locale';
import { buildClassName } from 'utils/build-class-name';
import { useThemeContext } from 'contexts';
import { ThemeNames } from 'types/themes';

import type Listing from 'data/listing';

interface Props {
  listing: Listing;
  isVisible: boolean;
}

// This component is for mobile only
export default function ListingPagePrice({ listing, isVisible }: Props) {
  const { statusLabel, isTreb, soldPrice, isSoldWithoutSoldPrice, price, isPrivate: listingIsPrivate, isCrea, providerId, isSignInAndTermsOfUseRequired } = listing;
  const { isAuthenticated } = useContext(UserContext) as IUserContext;
  const isPrivate = !isAuthenticated && listingIsPrivate;
  const isInactive = statusLabel === 'Inactive';
  const { openModal } = useContext(ModalContext) as IModalContext;
  const { t } = useTranslation(SiteNameSpace.Modal);
  const { themeName } = useThemeContext();
  const isExpTheme = themeName !== ThemeNames.ZOOCASA;

  const openSignInModal = () => {
    if (isPrivate || (isSignInAndTermsOfUseRequired && !isVisible && !isAuthenticated)) {
      openModal('login-registration', { warningMessage: t('login-registration.form.signinRequiredWarning') });
    } else if (!isVisible) {
      openModal('terms-of-use', { providerId });
    }
  };

  const renderLabel = () => {
    if (isPrivate || (isSignInAndTermsOfUseRequired && !isVisible && !isAuthenticated)) {
      return (
        <section className={styles.cta} onClick={openSignInModal}>
          <span data-testid={blurIds.overlaySignInBtn} className={isExpTheme && styles['sign-in-exp']}>Sign in</span> to see price
        </section>
      );
    } else if ((isCrea && !isVisible) || (isSignInAndTermsOfUseRequired && !isVisible)) {
      return (
        <section className={styles.cta} onClick={openSignInModal}>
          <span data-testid={blurIds.overlayAcceptTermsBtn} className={isExpTheme && styles['sign-in-exp']}>Accept Terms of Use</span> to see price
        </section>
      );
    }
  };

  return isInactive && !isTreb ? null :
    <div>
      {soldPrice && (
        <div>
          <div className={!isVisible ? `blur ${styles.price}` : styles.price} data-testid={blurIds.blurredListingPrice}>
            {formatCurrency(soldPrice)}
          </div>
          {isVisible && price &&
            <div className={styles['list-price']}>
              <span data-testid={listingPageModalIds.modalPriceInfoSection}>{formatCurrency(price)}</span>
            </div>
          }
        </div>
      )}
      {!soldPrice && price && (
        <>
          <div className={buildClassName(!isVisible ? `blur ${styles.price}` : styles.price, isSoldWithoutSoldPrice && styles['list-price-only'])} data-testid={blurIds.blurredListingPrice}>
            {isSoldWithoutSoldPrice && 'List: '}{formatCurrency(price)}
          </div>
          {renderLabel()}
        </>
      )}
    </div>;
}
